/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, {
  useState, useRef, useMemo, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import ResizeObserver from 'react-resize-observer';
import IcomoonReact from 'icomoon-react';
import { Formik, Form } from 'formik';
import { useTheme } from 'emotion-theming';
import Shimmer from '../../../../shared/_TBComponents/Shimmer';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import useCalendar from './hooks/useCalendar';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Spinner from '../../../../shared/components/Spinner/Spinner';
import Input from '../../../../shared/_TBComponents/Input/index';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import CreateLiftInputs from './CreateLiftInputs';
import {
  createExercise,
  fetchExerciseForAccount,
  updateExercise,
  updateExerciseMediaItems,
  setNewPreSaveItemFromCreateExerciseForm,
  addPreSavedItemToCalendarItemsArray,
  addPreSavedItemToProgramItemsArray,
} from '../../ducks/calendarActions';
import CreateSAQCFormInputs from './CreateSAQCFormInputs';
import CreateCircuitsFormInputs from './CreateCircuitsFormInputs';
import CreateNotesFormInputs from './CreateNotesFormInputs';
import CreateWarmUpOrCooldownFormInputs from './CreateWarmpUpOrCooldownFormInputs';
import CreateQuestionnaireFormInputs from './CreateQuestionnaireFormInputs';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import { EXERCISE_TYPE, calendarIcons } from '../../../../shared/constants';
import useCalendarAutoSaveCalendarItems from './hooks/useCalendarAutoSaveCalendarItems';
import { showErrorToast } from '../../../../shared/utils/toastManager';
import { axiosAuthed } from '../../../../shared/utils/setCommonHeaders';
import SimilarExercisesCheckModal from './SimilarExercisesCheckModal';
import ModalCtaButton from './ModalCtaButton';

const FormWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

const SpinnerWrapper = styled('div')`
.spinner-container {
  min-height: 500px;
}
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
  border: 2px solid ${({ theme }) => theme.colors.text};
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndTypeWrapper = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const ChangingInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const LoadingWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;
const LoadingShimmerTopRowWrapper = styled('div')`
  display: flex;
  width: 100%;
  gap: 16px;
  ${(props) => props.containerWidth < 528 && 'flex-wrap: wrap'};
`;

const TopInputLoadingShimmer = styled('div')`
  display: flex;
  height: 66px;
  width: 100%;
  border-radius: 4px;
`;

const DescriptionLoadingShimmer = styled('div')`
  display: flex;
  height: 290px;
  width: 100%;
  border-radius: 4px;
`;

const LoadingShimmerURLBox = styled('div')`
 display: flex;
 flex: 1;
 flex-direction: column;
 gap: 16px;
 border-radius: 4px;
 min-width: ${(props) => (props.containerWidth < 400
    ? '250px'
    : props.containerWidth >= 528 && props.containerWidth < 700
      ? '250px'
      : '350px')};
${(props) => (props.containerWidth >= 700 && 'max-width: 350px')};
`;

const LoadingShimmerBottomRow = styled('div')`
  display: flex;
  height: 100px;
  width: 100%;
  border-radius: 4px;
`;

const NoExerciseManagementOverlay = styled('div')`
display: flex;
align-items: center;
justify-content: center;
position: absolute;
height: 100%;
width: 100%;
z-index: 1000;
backdrop-filter: blur(1.5px);
`;

const ExerciseManagementWarning = styled('div')`
  display: flex;
  gap: 12px;
  background: ${({ theme }) => theme.colors.warningSurface};
  border: 1px solid ${({ theme }) => theme.colors.warningBorder};
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.warningText};
  p {
    font-size: 12pt;
  }
`;

const IconContainer = styled('div')`
  display: flex;
  min-width: 30px;
  jutify-content: center;
  align-items: center;
`;

const CreateNewExerciseForm = ({
  closeModal, onSuccessOverride, editExerciseId, unifiedVideoFlow, skipSimilarityCheck,
  onSimilarCheckOpenChange, isManageExercisesContext,
}) => {
  const dispatch = useDispatch();
  const {
    handleGetInitialValues,
    handleGetFormValidationSchema,
    handleGetUpdatedValuesToSubmit,
  } = useCalendar();
  const {
    handleAutoSaveCalendarItem,
  } = useCalendarAutoSaveCalendarItems();

  const typeSelectRef = useRef(null);
  const containerRef = useRef(null);
  const iframelyError = useSelector((state) => state.calendar.data.iframelyError);
  const isMediaLoading = useSelector((state) => state.calendar.ui.isMediaLoading);
  const isQuestionsForAccountLoading = useSelector((state) => state.calendar.ui.isQuestionsForAccountLoading);
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const sideBarExerciseSearchTerm = useSelector((state) => state.calendar.data.sideBarExerciseSearchTerm);
  const exercisePickerSearchTerm = useSelector((state) => state.calendar.data.exercisePickerSearchTerm);
  // Outside Build there is no sidebar search term, and a null seed trips Yup's type check before `required`.
  const searchTermForInitialValue = (modalData?.openedFromExercisePicker ? exercisePickerSearchTerm : sideBarExerciseSearchTerm) ?? '';
  const [modalType, setModalType] = useState(modalData?.type || 'L');
  const [persistedName, setPersistedName] = useState(
    searchTermForInitialValue,
  );
  const [containerWidth, setContainerWidth] = useState(null);
  const [isTypeChangeLoading, setIsTypeChangeLoading] = useState(false);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const hasExerciseManagementAccess = currentUser?.userSettings?.exercises === 1;

  const accountCode = currentUser?.accountCode;
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const date = new Date(selectedDate);
  const endpointFormattedDate = moment(date).format('YYYY-MM-DD');
  const isFetchedExerciseLoading = useSelector((state) => state.calendar.ui.isFetchedExerciseLoading);
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const weekViewHorizontallyExpandedDay = useSelector(
    (state) => state.calendar.data.weekViewExpandedDay,
  );
  const monthSelectionActiveDate = useSelector(
    (state) => state.calendar.data.monthSelectionActiveDate,
  );
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const { colors } = useTheme();

  /** Pending submission (matches + prepared values) held while the
   * "Check these similar exercises" modal awaits the coach's choice. */
  const [similarCheck, setSimilarCheck] = useState(null);
  const [isCheckingSimilar, setIsCheckingSimilar] = useState(false);

  // Host hides its create-exercise modal while the similarity dialog is up so
  // the two never stack; cleanup unhides it if this form unmounts mid-dialog.
  useEffect(() => {
    if (!onSimilarCheckOpenChange) return undefined;
    onSimilarCheckOpenChange(!!similarCheck);
    return () => onSimilarCheckOpenChange(false);
  }, [!!similarCheck]);

  /** Fetched here (not in the questionnaire inputs, which unmount behind the
   * loading spinner and would refire/loop) — list payload carries no questions. */
  useEffect(() => {
    if (modalData?.editModal && modalType === EXERCISE_TYPE.Questionnaire) {
      dispatch(fetchExerciseForAccount(accountCode, modalData?.itemInfoForEditModal?.id));
    }
  }, [modalData?.editModal]);

  /** Prefetched on name blur / type change so the answer is usually ready
   * before Save; keyed on (name, type) — either changing invalidates it. */
  const SIMILAR_CHECK_TIMEOUT_MS = 4000;
  const similarPrefetchRef = useRef({ key: null, promise: null });

  const fetchSimilarExercises = (name, type) => {
    const params = new URLSearchParams({ name, type });
    return axiosAuthed.get(`/accounts/${accountCode}/exercises/similar?${params.toString()}`)
      .then((res) => ({ status: 'ok', matches: res.data?.similarExercises || [] }))
      .catch((err) => ({ status: err?.response?.status === 400 ? 'duplicate' : 'error' }));
  };

  const prefetchSimilarExercises = (name, type) => {
    const trimmedName = (name || '').trim();
    if (!trimmedName || editExerciseId || skipSimilarityCheck) return;
    const key = `${trimmedName}|${type}`;
    if (similarPrefetchRef.current.key === key) return;
    similarPrefetchRef.current = { key, promise: fetchSimilarExercises(trimmedName, type) };
  };

  const LIFT_TRACKING_LABELS = {
    0: 'Disabled',
    1: 'Max Weight (1RM)',
    2: 'Highest Number of Reps',
    3: 'Max Weight 3RM',
    4: 'Highest Entered Weight',
  };

  const addPreSaveItemToBoard = (exercise) => {
    const iconEntry = Object.values(calendarIcons).find((ic) => ic.type === exercise.type);
    const newItem = {
      ...exercise,
      icon: iconEntry ? iconEntry.icon : calendarIcons[exercise.typeDescription]?.icon,
      title: exercise.name,
      exerciseId: parseInt(exercise.id, 10),
      id: `${exercise.id}-${generateUniqueId()}`,
      assignedId: `${exercise.id}-${generateUniqueId()}`,
      preSave: true,
    };
    dispatch(setNewPreSaveItemFromCreateExerciseForm(newItem));
    if (programType === 'free-form-program') {
      dispatch(addPreSavedItemToProgramItemsArray(newItem, weekViewHorizontallyExpandedDay != null && viewType === 'weekView' ? weekViewHorizontallyExpandedDay : selectedProgramDayNumber));
    } else {
      dispatch(addPreSavedItemToCalendarItemsArray(
        newItem,
        viewType === 'monthView' && monthSelectionActiveDate != null
          ? monthSelectionActiveDate
          : modalData?.targetDate
            || (weekViewHorizontallyExpandedDay != null && viewType === 'weekView'
              ? moment(weekViewHorizontallyExpandedDay).format('YYYY-MM-DD')
              : endpointFormattedDate),
      ));
    }
  };

  const handleMarkAllTouched = (formValues, setTouched) => {
    setTouched(
      Object.keys(formValues).reduce((acc, field) => {
        acc[field] = true;
        return acc;
      }, {}),
    );
  };

  // videoPending: a URL still resolving or file still uploading — submitting
  // then would save the exercise without its video, so hold the button.
  const isSubmitDisabled = (errors, touched, isSubmitting, videoPending) => {
    if (iframelyError || (Object.keys(errors).length > 0 && Object.keys(touched).length > 0) || Object.keys(touched).length === 0 || isMediaLoading || isSubmitting || videoPending) {
      return true;
    }
    return false;
  };

  const validateNameAndSetFieldErrorOnChange = async (value, setFieldError, nameValidationSchema) => {
    try {
      // eslint-disable-next-line no-unused-vars
      const validatedValue = await nameValidationSchema.validate(value);
    } catch (err) {
      setFieldError('name', err.message);
    }
  };

  const getTypeOptions = (currentTypeValue) => [
    {
      name: 'Lift',
      id: 'L',
      icon: 'lift',
      color: '#6C7A89',
      squareContainer: true,
      backgroundColor: 'rgba(108, 122, 137, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'L',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'SAQ+C',
      id: 'R',
      icon: 'cardio',
      color: '#59ABE3',
      squareContainer: true,
      backgroundColor: 'rgba(89, 171, 227, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'R',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Circuit',
      id: 'C',
      icon: 'circuit',
      color: '#F89406',
      squareContainer: true,
      backgroundColor: 'rgba(248, 148, 6, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'C',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Questionnaire',
      id: 'S',
      icon: 'science',
      color: '#9B59B6',
      squareContainer: true,
      backgroundColor: 'rgba(155, 89, 182, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'S',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Notes',
      id: 'N',
      icon: 'note',
      color: '#F9BF3B',
      squareContainer: true,
      backgroundColor: 'rgba(249, 191, 59, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'N',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Warm-Up',
      id: 'W',
      icon: 'warmup',
      color: '#E74C3C',
      squareContainer: true,
      backgroundColor: 'rgba(231, 76, 60, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'W',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Cooldown',
      id: 'CD',
      icon: 'cooldown',
      color: '#1787FB',
      squareContainer: true,
      backgroundColor: 'rgba(23, 135, 251, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'CD',
      checkmarkColor: colors.textTertiary,
    },
  ];

  const customSelectStylesType = {
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      borderColor: state.isFocused ? colors.hover : colors.borderLight,
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? colors.hover : colors.borderLight,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 12px',
      backgroundColor: state.isSelected ? colors.surfaceSecondary : colors.surfaceElevated,
      color: state.isSelected ? colors.textTertiary : colors.text,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      '&:hover': {
        backgroundColor: colors.surfaceSecondary,
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: colors.surfaceElevated,
      color: colors.text,
      border: '0px',
      minWidth: '200px',
      padding: '4px 0',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '100%',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: colors.textSecondary,
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontFamily: 'nunito sans',
    }),
  };

  const initialValues = useMemo(() => (
    handleGetInitialValues(modalType, persistedName, modalData, unifiedVideoFlow, isManageExercisesContext)
  ), [modalType, modalData, unifiedVideoFlow, isManageExercisesContext]);

  // The name often arrives prefilled (quick-add search term) and is never
  // blurred, so kick off the check on open too.
  useEffect(() => {
    prefetchSimilarExercises(initialValues?.name, modalType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SimilarExercisesCheckModal
        // Remount per check so the rename field re-initializes to the
        // currently proposed name.
        key={similarCheck?.proposedExercise?.name || 'similar-check-closed'}
        isOpen={!!similarCheck}
        proposedExercise={similarCheck?.proposedExercise}
        similarExercises={similarCheck?.matches || []}
        // Backing out returns to the still-open create form with the values
        // intact, so dismissing loses nothing.
        onClose={() => setSimilarCheck(null)}
        onUseExisting={(existingExercise) => {
          setSimilarCheck(null);
          if (onSuccessOverride) {
            onSuccessOverride(existingExercise);
          } else {
            addPreSaveItemToBoard(existingExercise);
          }
          closeModal();
        }}
        onProceed={(chosenName) => {
          const { run, updatedValues } = similarCheck;
          setSimilarCheck(null);
          run({ ...updatedValues, name: chosenName });
        }}
      />
      <Formik
          key={`${modalType}`}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={handleGetFormValidationSchema(modalType, modalData)}
          onSubmit={(values, { setSubmitting, setFieldError, errors }) => {
            /** returns an updated formatted values object based on type */
            const updatedValues = handleGetUpdatedValuesToSubmit(values, isManageExercisesContext);

            // Edit mode: PATCH instead of create. Create sends video as a media
            // id, but the update endpoint takes videoUrl — bridge it here.
            if (editExerciseId) {
              setSubmitting(true);
              const editBody = { ...updatedValues };
              delete editBody.mediaIds;
              if (unifiedVideoFlow ? values.mediaType !== 'VIDEO' : values.uploadOrUrl === 'url') {
                editBody.videoUrl = values.videoUrl || '';
              }

              // PATCH has no mediaIds field, so an uploaded/removed video is
              // persisted separately via the media-association PUT, only if changed.
              const persistMediaItems = (onDone) => {
                if (!unifiedVideoFlow || !values.videoDirty) {
                  onDone();
                  return;
                }
                dispatch(updateExerciseMediaItems(
                  accountCode,
                  editExerciseId,
                  values.mediaId ? [values.mediaId] : [],
                  {
                    onSuccess: onDone,
                    // Thunk already toasts; keep the modal open (matching the
                    // PATCH onError below) so the video change can be retried.
                    onError: () => setSubmitting(false),
                  },
                ));
              };

              dispatch(updateExercise(accountCode, editExerciseId, editBody, {
                onSuccess: (response) => {
                  persistMediaItems(() => {
                    setSubmitting(false);
                    if (onSuccessOverride) onSuccessOverride(response);
                    closeModal();
                  });
                },
                onError: () => setSubmitting(false),
              }));
              return;
            }

            if (!errors) {
              setSubmitting(true);
            }

            /** create new exercise for account with error handling */
            const submitCreate = (finalValues) => {
              dispatch(setNewPreSaveItemFromCreateExerciseForm(null));
              dispatch(createExercise(accountCode, finalValues, {
              // The AI import path (onSuccessOverride set) shows its own
              // feedback in the wizard — suppress the calendar's "Exercise
              // created" success toast and createExercise's generic error toast
              // so they don't leak on top of the wizard UI.
                silent: !!onSuccessOverride,
                onSuccess: (response) => {
                /** onSuccessOverride (Manage Exercises, AI import swap flow) skips
                 all calendar/program side effects and hands the response to the host. */
                  if (onSuccessOverride) {
                    setSubmitting(false);
                    onSuccessOverride(response);
                    closeModal();
                    return;
                  }
                  /** if the type created is questionnaire, warm up, cooldown, health
                 notes or progression then we are going to save the
                 the calendar item directly and add it, if it is any other exercise type we
                 need to create a presave item instead
                 */
                  if (response?.type === EXERCISE_TYPE.Questionnaire
                   || response?.type === EXERCISE_TYPE.WarmUp
                   || response?.type === EXERCISE_TYPE.Cooldown
                   || response?.type === EXERCISE_TYPE.Health
                   || response?.type === EXERCISE_TYPE.Note
                   || response?.type === EXERCISE_TYPE.Progression) {
                    handleAutoSaveCalendarItem(response, setSubmitting, closeModal);
                  } else {
                    setSubmitting(false);
                    /** if add exercise is successful then add pre save item and close modal */
                    addPreSaveItemToBoard(response);
                    closeModal();
                  }
                },
                onError: (message) => {
                  setSubmitting(false);
                  showErrorToast(message || 'Opps! Something went wrong. Unable to create new exercise.');
                },
              }));
            };

            /** Advisory check: a literal name+type duplicate 400s into a field
             * error, but an unavailable check must never block creation. */
            const isReusable = values.type === 'L' || values.reusableItem === 1
              || values.reusableItem === true || modalData?.reusableItem === 1
              || modalData?.reusableItem === true;
            const proposedName = (updatedValues.name || values.name || '').trim();
            if (!isReusable || !proposedName || skipSimilarityCheck) {
              submitCreate(updatedValues);
              return;
            }
            // Use the prefetched result if it matches (name, type); otherwise
            // fire fresh. Wait is capped — past it, creation proceeds unchecked.
            const key = `${proposedName}|${values.type}`;
            const pending = similarPrefetchRef.current.key === key
              ? similarPrefetchRef.current.promise
              : fetchSimilarExercises(proposedName, values.type);
            similarPrefetchRef.current = { key, promise: pending };
            const timeout = new Promise((resolve) => {
              setTimeout(() => resolve({ status: 'error' }), SIMILAR_CHECK_TIMEOUT_MS);
            });
            setIsCheckingSimilar(true);
            Promise.race([pending, timeout]).then((result) => {
              setIsCheckingSimilar(false);
              if (result.status === 'duplicate') {
                setSubmitting(false);
                setFieldError('name', 'Name already exists in your database for this exercise type, choose a different name to create exercise.');
                return;
              }
              if (result.status !== 'ok' || !result.matches.length) {
                submitCreate(updatedValues);
                return;
              }
              setSubmitting(false);
              setSimilarCheck({
                matches: result.matches,
                updatedValues,
                proposedExercise: {
                  name: proposedName,
                  typeName: getTypeOptions(values.type)?.find((o) => o.id === values.type)?.name,
                  trackingName: values.type === EXERCISE_TYPE.Lift
                    ? LIFT_TRACKING_LABELS[values.tracking]
                    : null,
                },
                run: (finalValues) => {
                  setSubmitting(true);
                  submitCreate(finalValues);
                },
              });
            });
          }}
          render={({
            errors,
            touched,
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            handleBlur,
            setFieldTouched,
            setFieldError,
            isSubmitting,
            validateForm,
            setTouched,
          }) => {
            const isReusableItem = modalData?.reusableItem === 1 || values.reusableItem === 1 || values.reusableItem === true || modalData?.reusableItem === true || values.type === 'L';
            /** if there is an initial value for name then marked that
             * field as touched and validate the value
             */
            if (values.name && !touched.name) {
              setTouched({ name: true });
              validateNameAndSetFieldErrorOnChange(values.name, setFieldError, handleGetFormValidationSchema(modalType)?.name, modalData);
            }
            /** if the type is note, cooldown or warm up and it's not a reusable item we
             * don't need to validate name so we are going to mark the field as touhced so that
             * we don't disalbed the save button in this case
             */
            if ((values?.reusableItem === false || values?.reusableItem === 0) && (values?.type === 'N' || values?.type === 'CD' || values?.type === 'W') && !touched.name) {
              setTouched({ name: true });
            }
            return (
              <Form>
                <FormWrapper>
                  {!modalData?.disabledEditModal && !hasExerciseManagementAccess && modalType === EXERCISE_TYPE.Lift && (
                  <NoExerciseManagementOverlay>
                    <ExerciseManagementWarning>
                      <IconContainer>
                        <IcomoonReact
                        iconSet={iconSet}
                        size={24}
                        icon='warning'
                        color='#F59E0B'
                        />
                      </IconContainer>
                      <Text>You do not have the user permissions required to save to the exercise database. Please Contact your administrator for more details.</Text>
                    </ExerciseManagementWarning>
                  </NoExerciseManagementOverlay>
                  )}
                  {isSubmitting || (values.type === 'S' && isFetchedExerciseLoading) ? (
                    <SpinnerWrapper>
                      <Spinner />
                      {isCheckingSimilar && (
                        <Text fontSize='16px' fontWeight={700} style={{ textAlign: 'center' }}>
                          Checking your exercise...
                        </Text>
                      )}
                    </SpinnerWrapper>
                  ) : (
                    <>
                      <ResizeObserver
                        onResize={(rect) => {
                          setContainerWidth(rect?.width);
                        }}
                      />
                      <NameAndTypeWrapper>
                        <Input
                          disabled={modalData?.disabledEditModal}
                          error={!!touched.name && !!errors.name}
                          errorMsg={errors.name}
                          fontSize='16px'
                          fontWeight={400}
                          height='38px'
                          label='Name'
                          name='name'
                          onChange={(value) => {
                            setPersistedName(value.target.value);
                            handleChange(value);
                            setTouched({ name: true });
                            validateNameAndSetFieldErrorOnChange(value, setFieldError, handleGetFormValidationSchema(modalType, modalData)?.name);
                          }}
                          onBlur={(e) => {
                            handleBlur(e);
                            prefetchSimilarExercises(e?.target?.value ?? values.name, values.type);
                          }}
                          right='5px'
                          styledPropsLabel={{
                            fontSize: '16px',
                            fontWeight: 700,
                          }}
                          styledPropsWrapper={{
                            flex: 1,
                          }}
                          top='38px'
                          value={values.name}
                          width='100%'
                        />
                        <div style={{ zIndex: !hasExerciseManagementAccess && 1001, display: 'flex', minWidth: containerWidth < 527 ? '100%' : '200px' }} ref={typeSelectRef}>
                          <SelectBox
                            isDisabled={modalData?.disabledEditModal || !!editExerciseId}
                            width='200px'
                            options={getTypeOptions(values.type)}
                            defaultValue={getTypeOptions(values.type)?.find((option) => option.id === values.type)}
                            onChangeFunction={(option) => {
                              setFieldValue('type', option.id);
                              setModalType(option.id);
                              prefetchSimilarExercises(values.name, option.id);
                              if (option.id !== values.type) {
                                setIsTypeChangeLoading(true); /** Set loading to true immediately */

                                setTimeout(() => {
                                  setIsTypeChangeLoading(false); /** Change loading back to false after 800ms */
                                }, 800);
                              }
                            }}
                            onBlur={() => setFieldTouched('type', true)}
                            error={!!touched.type && !!errors.type}
                            errorMsg={errors.type}
                            title='Type'
                            titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                            customStyles={customSelectStylesType}
                            isClearable={false}
                          />
                        </div>
                      </NameAndTypeWrapper>
                      {isTypeChangeLoading || isQuestionsForAccountLoading ? (
                        <LoadingWrapper>
                          <LoadingShimmerTopRowWrapper containerWidth={containerWidth}>
                            <Shimmer>
                              <LoadingShimmerURLBox containerWidth={containerWidth} />
                            </Shimmer>
                            <div style={{
                              display: 'flex', flexDirection: 'column', width: '100%', gap: '16px',
                            }}
                            >
                              <Shimmer>
                                <TopInputLoadingShimmer />
                              </Shimmer>
                              <Shimmer>
                                <DescriptionLoadingShimmer />
                              </Shimmer>
                            </div>
                          </LoadingShimmerTopRowWrapper>
                          <Shimmer>
                            <LoadingShimmerBottomRow />
                          </Shimmer>
                        </LoadingWrapper>
                      ) : (
                        <ChangingInputsContainer>
                          {modalType === EXERCISE_TYPE.Lift && (
                          <CreateLiftInputs
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            mediaType={values.mediaType}
                            videoUrlValue={values.videoUrl}
                            mediaUrlValue={values.mediaUrl}
                            mediaIdValue={values.mediaId}
                            trackingValue={values.tracking}
                            linkToValue={values.linkTo}
                            linkPercentageValue={values.linkPercentage}
                            setFieldValue={setFieldValue}
                            handleBlur={handleBlur}
                            setFieldTouched={setFieldTouched}
                            setTouched={setTouched}
                            setFieldError={setFieldError}
                            urlButtonValue={values.uploadOrUrl}
                            containerWidth={containerWidth}
                            completionOnlyValue={values.completionOnly}
                            coachCompletionValue={values.coachCompletion}
                            linkPercentageValidationSchema={handleGetFormValidationSchema(modalType, modalData)?.linkPercentage}
                            updateLinkedExerciseMaxValue={values.updateLinkedExerciseMax}
                            boadyWeightLiftValue={values.bodyweightLift}
                            trackVolumeLoadValue={values.trackVolumeLoad}
                            trackRepCountValue={values.trackRepCount}
                            barSpeedValue={values.barSpeed}
                            eachSideValue={values.eachSide}
                            peakPowerValue={values.peakPower}
                            tagsValue={values.tags}
                            hasExerciseManagementAccess={hasExerciseManagementAccess}
                            isManageExercisesContext={isManageExercisesContext}
                            unifiedVideoFlow={unifiedVideoFlow}
                          />
                          )}
                          {modalType === EXERCISE_TYPE.SAQC && (
                          <CreateSAQCFormInputs
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          mediaIdValue={values.mediaId}
                          trackingValue={values.tracking}
                          linkToValue={values.linkTo}
                          linkPercentageValue={values.linkPercentage}
                          updateLinkedExerciseMaxValue={values.updateLinkedExerciseMax}
                          tagsValue={values.tags}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          setFieldTouched={setFieldTouched}
                          setTouched={setTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          linkPercentageValidationSchema={handleGetFormValidationSchema(modalType, modalData)?.linkPercentage}
                          inputTypeValue={values.inputType}
                          unitValue={values.unit}
                          prSortOrderValue={values.prSortOrder}
                          reusableItemValue={values.reusableItem}
                          completionOnlyValue={values.cardioComp}
                          coachCompletionValue={values.cardioCoach}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          isManageExercisesContext={isManageExercisesContext}
                          unifiedVideoFlow={unifiedVideoFlow}
                          documentId={values.documentId}
                          documentUrl={values.documentUrl}
                          />
                          )}
                          {modalType === EXERCISE_TYPE.Circuit && (
                          <CreateCircuitsFormInputs
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          mediaIdValue={values.mediaId}
                          trackingValue={values.tracking}
                          linkToValue={values.linkTo}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          setFieldTouched={setFieldTouched}
                          setTouched={setTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          inputTypeValue={values.inputType}
                          prSortOrderValue={values.prSortOrder}
                          trackValue={values.track}
                          coachCompletionValue={values.coachCompletion}
                          documentId={values.documentId}
                          documentUrl={values.documentUrl}
                          reusableItemValue={values.reusableItem}
                          detailValue={values.detail}
                          detailTypeValue={values.detailType}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          isManageExercisesContext={isManageExercisesContext}
                          unifiedVideoFlow={unifiedVideoFlow}
                          />
                          )}

                          {modalType === EXERCISE_TYPE.Questionnaire && (
                          <CreateQuestionnaireFormInputs
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          reusableItemValue={values.reusableItem}
                          trackingValue={values.track}
                          questionnaireThresholdsEnabledValue={values.questionnaireThresholdsEnabled}
                          questionnaireThresholdsInvertedValue={values.questionnaireThresholdsInverted}
                          questionnaireThresholdLowValue={values.questionnaireThresholdLow}
                          questionnaireThresholdHighValue={values.questionnaireThresholdHigh}
                          questionIdValues={values.questionIds}
                          questions={values.questions}
                          setTouched={setTouched}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          isManageExercisesContext={isManageExercisesContext}
                          documentId={values.documentId}
                          documentUrl={values.documentUrl}
                          />
                          )}
                          {modalType === EXERCISE_TYPE.Note && (
                          <CreateNotesFormInputs
                          errors={errors}
                          touched={touched}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          mediaIdValue={values.mediaId}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          reusableItemValue={values.reusableItem}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          isManageExercisesContext={isManageExercisesContext}
                          unifiedVideoFlow={unifiedVideoFlow}
                          documentId={values.documentId}
                          documentUrl={values.documentUrl}
                          />
                          )}
                          {(modalType === EXERCISE_TYPE.WarmUp || modalType === EXERCISE_TYPE.Cooldown) && (
                          <CreateWarmUpOrCooldownFormInputs
                          errors={errors}
                          touched={touched}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          mediaIdValue={values.mediaId}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          reusableItemValue={values.reusableItem}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          isManageExercisesContext={isManageExercisesContext}
                          unifiedVideoFlow={unifiedVideoFlow}
                          documentId={values.documentId}
                          documentUrl={values.documentUrl}
                          />
                          )}
                        </ChangingInputsContainer>
                      )}
                    </>
                  )}
                  {(!modalData?.disabledEditModal && !hasExerciseManagementAccess && modalType === EXERCISE_TYPE.Lift) ? (null) : (
                    <ButtonsContainer ref={containerRef}>
                      {modalData?.disabledEditModal ? (
                        null
                      ) : (
                        <ModalCtaButton
                      type='button'
                      primary
                      marginTop={6}
                      onClick={() => {
                        if (isSubmitDisabled(errors, touched, isSubmitting, values.videoPending)) {
                          handleMarkAllTouched(values, setTouched);
                          validateForm();
                        } else {
                          handleSubmit();
                        }
                      }}
                      aria-disabled={isSubmitDisabled(errors, touched, isSubmitting, values.videoPending)}
                        >
                          {editExerciseId ? 'SAVE CHANGES' : (isReusableItem ? 'SAVE AND ADD' : 'ADD EXERCISE')}
                        </ModalCtaButton>
                      )}
                      {modalData?.disabledEditModal && !modalData?.isPreviewOnly && (
                      <ModalCtaButton
                      type='button'
                      primary
                      marginTop={6}
                       onClick={() => {
                         const itemInfo = modalData?.itemInfoForEditModal;
                         const newItem = {
                           ...itemInfo,
                           icon: calendarIcons[itemInfo.typeDescription].icon,
                           title: itemInfo.name,
                           exerciseId: parseInt(itemInfo.id, 10),
                           id: `${itemInfo.id}-${generateUniqueId()}`,
                           assignedId: `${itemInfo.id}-${generateUniqueId()}`,
                           preSave: true,
                         };
                         /** set redux call to add pre saved item to calendar items array or program items array in redux */
                         if (programType === 'free-form-program') {
                           dispatch(addPreSavedItemToProgramItemsArray(newItem, weekViewHorizontallyExpandedDay != null && viewType === 'weekView' ? weekViewHorizontallyExpandedDay : selectedProgramDayNumber));
                         } else {
                           dispatch(addPreSavedItemToCalendarItemsArray(
                             newItem,
                             viewType === 'monthView' && monthSelectionActiveDate != null
                               ? monthSelectionActiveDate
                               : modalData?.targetDate
                                 || (weekViewHorizontallyExpandedDay != null && viewType === 'weekView'
                                   ? moment(weekViewHorizontallyExpandedDay).format('YYYY-MM-DD')
                                   : endpointFormattedDate),
                           ));
                         }
                         closeModal();
                       }}
                      >
                        ADD EXERCISE
                      </ModalCtaButton>
                      )}
                      <CancelButton onClick={() => {
                        closeModal();
                      }}
                      >
                        {modalData?.disabledEditModal ? (
                          <Text fontSize='16px' fontWeight={700}>CLOSE</Text>
                        ) : (
                          <Text fontSize='16px' fontWeight={700}>CANCEL</Text>
                        )}
                      </CancelButton>
                    </ButtonsContainer>
                  )}
                </FormWrapper>
              </Form>
            );
          }}
      />
    </>
  );
};

CreateNewExerciseForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  // Optional override invoked with the created exercise instead of the
  // form's default success path. Used by the AI import wizard to plug a
  // newly-created exercise into its row mapping.
  onSuccessOverride: PropTypes.func,
  // When set, the form edits this exercise (PATCH) instead of creating; prefill
  // comes from `modalData.itemInfoForEditModal`. Omitted = create.
  editExerciseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // Gates the unified paste-or-upload video block. Default false keeps the
  // legacy VideoAndUrlInputs flow pixel- and behavior-identical.
  unifiedVideoFlow: PropTypes.bool,
  // Suppresses the similar-exercises step on create for callers (Manage
  // Exercises) with no destination for "Use existing". Duplicate error still applies.
  skipSimilarityCheck: PropTypes.bool,
  // Called with true/false as the similarity dialog opens/closes so the host
  // can visually hide its create-exercise modal underneath.
  onSimilarCheckOpenChange: PropTypes.func,
  isManageExercisesContext: PropTypes.bool,
};

CreateNewExerciseForm.defaultProps = {
  onSuccessOverride: null,
  editExerciseId: null,
  unifiedVideoFlow: false,
  skipSimilarityCheck: false,
  onSimilarCheckOpenChange: null,
  isManageExercisesContext: false,
};

export default CreateNewExerciseForm;
